module.exports = __webpack_public_path__ + "img/SJCX.50e86f31.svg";